module.exports = __webpack_public_path__ + "static/media/proximanova-medium.46824d7f.ttf";